export interface AutoTouchDate {
  cost: number
  hour: string
}

export enum AutoTouchStatus {
  TOUCH_SUCCESS = 'touch_success',
  TOUCH_FAIL = 'touch_fail'
}
export interface AutoTouchAvailabilityRaw {
  monday: Array<AutoTouchDate>
  tuesday: Array<AutoTouchDate>
  wednesday: Array<AutoTouchDate>
  thursday: Array<AutoTouchDate>
  friday: Array<AutoTouchDate>
  saturday: Array<AutoTouchDate>
  sunday: Array<AutoTouchDate>
}
export interface AutoTouchScheduleRaw {
  costMultiplier: number
  day: string
  hour: string
  cost?: number
}

export interface AutoTouchAvailability {
  [key: string]: {
    cost: number
    date: string
    formatedHour: string
    hour: string
    isSelected: boolean
  }
}
export interface AutoTouchHistory {
  status: AutoTouchStatus
  cost: number
  day: string
  date: string
  hour: string
}
export interface AutoTouchSchedule {
  classifiedId: number
  expires: string
  id: number
  history: AutoTouchHistory
  schedule: Array<{
    costMultiplier: number
    day: string
    hour: string
  }>
  touchedCount: number
}

export interface AutoTouchOneClick {
  price: number
  oldPrice?: number
  priceCredits: number
  oldPriceCredits: null
  preferredPayment: 'credits' | 'stripe'
  autoTouch: AutoTouchOneClickData | null
}

export interface AutoTouchOneClickData {
  isOneClickAutoTouch: boolean
  lastTouchError: string | null
  schedule: AutoTouchScheduleRaw[]
  expires: number
  isActive: boolean
  touchedCount: number
  id: number
  classifiedId: number
  history: AutoTouchHistory[]
}

export interface AutoTouchOneClickStripeDetails {
  url: string
  session: string
}
